
export default {
    data() {
        return {
            //当前批次的id
            currentBatchId: '',
            //被勾选的学生数组
            students: [],
            //批次的每页要的数量
            batchLength: 15,
            //批次的偏移量
            batchOffset: 0,
            //批次总数量
            batchTotal: 0,
            //来搜索批次的备注
            batchNameSearch: '',
            //按照批次时间搜索
            selectTime: '',
            //把搜索的时间转化格式
            batchTime: '',
            //存储批次的数组
            batchs: [],
            //存储批次里面的学员数组
            students: [],
            //存储批次里面的课程的数组
            lessons: [],
            //课程统计的价格
            lessonStatisticsMoney: 0,
            //课程统计的学时
            lessonPeroid: 0,
            //测试
            test: [
                {
                    name: '1'
                }, {
                    name: '1'
                }
            ],
            //下载批量开课模板
            download: this.baseUrl + 'excel/Batch_class_templates.xlsx',
            // 上传的地址
            address: this.baseUrl + 'purchased/batchClasses?token=' + this.$store.state.authority_management,
            //上传的批量开课excel文件储存
            fileListTwo: [],
            // 批量开课返回的学员信息
            registerInfo: [],
        }
    },
    methods: {
        // 上传excel批量注册用户
        httpreq(q) {
            // // console.log(q);
            this.$upload(this.address, q).then(res => {

                if (res.data.result.status === 'fail') {
                    let errorMsgList = res.data.result.result;
                    let htmlMsg = '';
                    errorMsgList.forEach(item => {
                        htmlMsg += `<span>${item}</span><br>`;
                    });
                    this.$alert(htmlMsg, '错误提示', {
                        confirmButtonText: '确定',
                        dangerouslyUseHTMLString: true
                    })
                    return
                }

                this.$message({
                    message: '批量开课完成',
                    type: 'success'
                })

                this.registerInfo = res.data.result.result
            })
        },
        //上传excel批量注册的三个方法
        //上传前
        beforeUploadTwo(file) {
            let str = file.name;
            if (str.substr(str.length - 4, 4).toLocaleLowerCase() != "xlsx") {
                alert('excel文件必须是xlsx格式')
                return false;
            }
        },
        //上传超出数量限制
        handleExceedTwo(files, fileList) {
            this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        //上传移除
        beforeRemoveTwo(file) {
            return this.$confirm(`确定移除 ${file.name}？`);
        },

        //获取已经勾选的学生数组
        handleStudentChange(val) {
            this.students = val;
        },
        //每页请求的条数发生变化时候
        handleSizeChangeBatch(length) {
            //改变每页请求的数目
            this.batchLength = length;
            this.getAllBatch();
        },
        //当前页数发生改变
        handleCurrentChangeBatch(page) {
            //把传来的当前页计算出偏移量
            this.batchOffset = (page - 1) * this.batchLength
            this.getAllBatch();
        },
        //获取所有批次
        getAllBatch() {
            //因为清除按钮会把时间默认清除到1970-01-01
            String(this.selectTime) == 'null' ? this.batchTime = '' : this.batchTime;
            //请求的data
            let data = {
                token: this.$store.state.authority_management,
                length: this.batchLength,
                offset: this.batchOffset,
                remarks: this.batchNameSearch,
                created_at: this.batchTime,
                shop_id: this.$store.state.store.id
            }
            this.$post('selected_batch/search', data).then(res => {
                // // console.log(res.data);
                this.batchs = res.data.result.data;
                this.batchTotal = res.data.result.total;
            })
        },
        //设置改批次无效
        setBatchLoseEfficacy(obj) {
            let name = obj.remarks;
            let data = {
                token: this.$store.state.authority_management,
                state: '0',
                id: obj.id
            }
            this.$post('selected_batch/edit', data).then(res => {
                if (res.data.status == 'success') {
                    this.$alert('设置批次：' + name + '为无效成功', '设置成功', {
                        confirmButtonText: '确定',
                    });
                    //设置批次状态再次请求数据更新
                    this.searchBatch();
                } else {
                    this.$message({
                        message: '设置无效失败',
                        type: 'error'
                    })
                }
            })
        },
        //按照条件搜索批次
        searchBatch() {
            //判断时间是否输入了
            if (this.selectTime != "" && String(this.selectTime) != "null") {
                // 搜索时间的转换
                var d = new Date(this.selectTime);
                let year = d.getFullYear(),
                    month = d.getMonth() + 1 >= 10 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1),
                    day = d.getDate() >= 10 ? d.getDate() : '0' + d.getDate();
                let time = year + '-' + month + '-' + day;
                this.batchTime = time;
            }
            this.getAllBatch();

        },
        //获取开课信息
        getOpenClassInfo(obj) {
            this.currentBatchId = obj.id;
            //置空一下课程总价格
            this.lessonStatisticsMoney = 0;
            this.lessonPeroid = 0;
            let data = {
                selected_batch_id: obj.id,
                token: this.$store.state.authority_management,
                offset: 0,
                length: 999
            }
            //获取开课的课程
            this.$post('selected/search_group_by_product', data).then(res => {
                this.lessons = res.data.result.data;
                //计算总价格
                for (let val of this.lessons) {
                    this.lessonStatisticsMoney += Number.parseFloat(val.product_price);
                    if (isNaN(this.lessonStatisticsMoney)) {
                        this.lessonStatisticsMoney = 0
                    }
                    this.lessonPeroid += Number.parseFloat(val.product_period);
                }
            });
            //获取开课的学员
            this.$post('selected/search_group_by_user', data).then(res => {
                this.students = res.data.result.data;

            });
        },
        //确定开课
        confirmOpenClass() {
            let user_id_arr = [];
            let product_id = [];
            //求出课程id数组
            for (let val of this.lessons) {
                product_id.push(val.product_id);
            }
            //求出学员id数组
            for (let val of this.students) {
                user_id_arr.push(val.user_id);
            }
            let data = {
                token: this.$store.state.authority_management,
                user_id_arr: JSON.stringify(user_id_arr),
                product_ids: JSON.stringify(product_id)
            }
            let dataTwo = {
                token: this.$store.state.authority_management,
                state: '2',
                id: this.currentBatchId
            }
            //给学员开课
            this.$post('orders/batch_create', data).then(res => {
                if (res.data.status == 'success') {
                    //开课成功要把相应批次的状态改成已完成开课
                    this.$post('selected_batch/edit', dataTwo).then(res => {
                        if (res.data.status == 'success') {
                            this.$alert('开课成功', '开课成功', {
                                confirmButtonText: '确定',
                            });
                        } else {
                            this.$message({
                                message: '开课失败',
                                type: 'error'
                            });
                        }
                    })
                } else {
                    this.$message({
                        message: '开课失败',
                        type: 'error'
                    });
                }
            })
        },
    },
    created() {
        this.getAllBatch();
    }
}
